import MPAAddNewCustomer from './MPAAddNewCustomer';

export default MPAAddNewCustomer;
